import { Box, Stack, Typography } from '@mui/joy';
import { IoSearch } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

export interface QuickSearch {
  label: string;
  query?: string;
}

export const DEFAULT_QUICK_SEARCHES: QuickSearch[] = [
  { label: 'CORSIA' },
  { label: 'ICVCM' },
  { label: 'Article 6' },
  { label: 'Commentary' },
  { label: 'News & events', query: 'News Events' },
  { label: 'Ratings approach' },
];

interface CategoryQuickSearchesProps {
  items?: QuickSearch[];
}

const CategoryQuickSearches = ({ items = DEFAULT_QUICK_SEARCHES }: CategoryQuickSearchesProps) => {
  const navigate = useNavigate();

  return (
    <Box
      display='flex'
      flexWrap='wrap'
      alignItems='center'
      justifyContent='center'
      gap={2}
      width='100%'
    >
      {items.map(({ label, query }) => (
        <Stack
          key={label}
          direction='row'
          alignItems='center'
          justifyContent='center'
          gap={1.25}
          onClick={() => navigate(`/research-hub/search?q=${encodeURIComponent(query ?? label)}`)}
          sx={(theme) => ({
            cursor: 'pointer',
            p: '14px',
            borderRadius: 'md',
            backgroundColor: theme.palette.background.surface,
            border: `1px solid ${theme.palette.border.border}`,
            color: theme.palette.text.primary,
            transition: 'background-color 120ms ease, border-color 120ms ease',
            '&:hover': { backgroundColor: theme.palette.primary.outlinedHoverBg },
          })}
        >
          <IoSearch size={20} aria-hidden />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: 1.42,
              color: 'inherit',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Typography>
        </Stack>
      ))}
    </Box>
  );
};

export default CategoryQuickSearches;
